// extracted by mini-css-extract-plugin
module.exports = {"modal":"_ns","container":"_nt","actions":"_nu","button":"_nv","text":"_nw"};